module.exports = __webpack_public_path__ + "media/flags/tc-654f7323.svg";